import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import colors from 'shared-tokens/utils/tokens/colors';

import { mainCls as baseCls } from '../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__footer`;

export default {
  [mainCls]: {
    height: 50,
    minHeight: 50,
    zIndex: 3,
    [brpM]: {
      height: 60,
      minHeight: 60,
    },
    borderTop: '1px solid #D8DBDF',
    background: '#FFF',
  },
  [`${mainCls}__h100`]: {
    height: '100%',
    justifyContent: 'center',
    alignContent: 'center',
  },
  [`${mainCls}__utils`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    [brpM]: {
      display: 'none',
      
    },
  },
  [`${mainCls}__utilsbtn`]: {
    'width': 24,
    'height': 24,
    'transition': createTransition(['color']),
    '& svg path': {
      strokeWidth: 1.2,
    },
    '&:hover': {
      color: `${colors.f0.rgba}!important`,
    },
  },
  [`${mainCls}__leadbtn`]: {
    maxWidth: '50%',
    maxHeight: '40px',
    'border': '0 none',
    'transition': createTransition(['background']),
    lineHeight: 1,
    flexGrow: 1,
    '&:hover': {
      background: '#A30000 !important',
    },
  },
  [`${mainCls}__btn-detail`]: {
    maxWidth: '50%',
    maxHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    border: '1px solid #D8DBDF',
    lineHeight: 1,
    whiteSpace: 'pre',
    flexGrow: 1,
  }
};
